import { reactive } from 'vue';

// Tiny cross-component signal: the header's "Ristruttura" pill lives outside the
// home page's renovation section, so it can't flip that section's `showChoice`
// flag directly. It bumps this counter instead; HomeRenovationCall watches it and
// opens its "Come vuoi iniziare?" choice popup (Videocall / Preventivo). A counter
// (not a boolean) so repeated clicks re-fire the watcher every time.
export const renovationCta = reactive({ openRequests: 0 });

export function requestRenovationChoice() {
  renovationCta.openRequests += 1;
}
